const CONFIRM_SERVICE = 'Confirm Service';
const _redirectBasedOnType = (url) => {
    if(isFunction(url)){
        url()
    }
    else {
        ontech.redirect(url)
    }
}

const adtClientNameChangeByWorkOrder = () => {
    if(!isEmpty(ontech.state.get(State.ParentOrder.WORK_ORDER))) {
        if (ontech.state.get(State.ParentOrder.WORK_ORDER).length === 16) {
            ontech.state.do(State.Actions.CLIENT_NAME_CHANGED, ClientNames.DishTV_ADT);
        } else {
            ontech.state.do(State.Actions.CLIENT_NAME_CHANGED, ClientNames.OnTech_ADT);
        }
    }
};

function updateADTAttributes(adtCustomerCsNumberIdVal, adtCustomerCsSiteNoIdVal, onSuccessURL) {
    let attributes = createADTCartAttributes(adtCustomerCsNumberIdVal, adtCustomerCsSiteNoIdVal);
    ontech.updateCart(attributes, 'updateADTAttributes')
        .then(() => _redirectBasedOnType(onSuccessURL))
        .catch(function (error) {
            let errMsg = "Couldn't Capture the Account Numbers, Please Reenter The CS And Site Number"
            window.showToast(errMsg, "error");
            sleep(() => {
                if (ontech.state.get(State.Adt.CS_NUMBER) && ontech.state.get(State.Adt.SITE_NUMBER)) {
                    _redirectBasedOnType(onSuccessURL)
                } else {
                    $('#customOssCsAccountNumberModal').modal("show");
                }
            });
        });
}

const adtCustomerCsNumberSubmitClick = (onSuccessURL) => {
    $("#adtCustomerCsNumberSubmit").on('click', function () {
        const adtCustomerCsNumberIdVal = $('#adtCustomerCsNumberInputId').val();
        const adtCustomerCsSiteNoIdVal = $('#adtCustomerSiteNumberInputId').val();
        adtClientNameChangeByWorkOrder();

        if (adtCustomerCsNumberIdVal && adtCustomerCsSiteNoIdVal) {
            $('#customOssCsAccountNumberModal').modal("hide");
            //Setting the CS Number and Site Number States.
            ontech.state.do(State.Actions.ADT_CS_NUMBER_SET, adtCustomerCsNumberIdVal);
            ontech.state.do(State.Actions.ADT_SITE_NUMBER_SET, adtCustomerCsSiteNoIdVal);
            updateADTAttributes(adtCustomerCsNumberIdVal, adtCustomerCsSiteNoIdVal, onSuccessURL);
        } else {
            if (!adtCustomerCsNumberIdVal) {
                $('#CsAccountNumError').text('Please insert the customer CS account #');
            } else {
                $('#CsAccountNumError').text('');
            }

            if (!adtCustomerCsSiteNoIdVal) {
                $('#CsSiteNumError').text('Please insert the customer CS account #');
            } else {
                $('#CsSiteNumError').text('');
            }
        }
    });
};

const cartContainsQualifyingGoogleShaProduct = async function (cart) {
    let shaQualified = false;
    try {
        if(isEmpty(cart)) {
            cart = await ontech.getCart('cartContainsQualifyingGoogleShaProduct');
        }

        for (const cartItem of cart.items) {
            const productTagsList = cartItem.properties[Cart.Properties.PRODUCT_TAGS].split(",");
            if (cartItem.properties
                && cartItem.properties[Cart.Properties.PRODUCT_TAGS]
                && listIncludesIgnoreCase((productTagsList), 'sha-discount-enabled-product', true)
            ) {
                shaQualified = true;
            }
        }
    } catch (err) {
        ontech.log.error('Error in checkout scripts cartContainsQualifyingGoogleShaProduct', err);
    }
    return shaQualified;
};

// Handle ADT REFERENCE CS Number Modal Click => adtCustomerCsNumberSubmit
const CsReferenceHandleClickEvent = (onSuccessURL) => {
    if(
        isEmpty(ontech.state.get(State.Adt.CS_NUMBER), true)
        || isEmpty(ontech.state.get(State.Adt.SITE_NUMBER), true)
    ){
        $('#customOssCsAccountNumberModal').modal("show");
        adtCustomerCsNumberSubmitClick(onSuccessURL);
    }
    else {
        updateADTAttributes(ontech.state.get(State.Adt.CS_NUMBER), ontech.state.get(State.Adt.SITE_NUMBER), onSuccessURL);
    }
}

const createADTCartAttributes = (adtCustomerCsNumberIdVal, adtCustomerCsSiteNoIdVal) => {
    return {
        "attributes": {
            [NoteAttribute.PARTNER_REFERENCE_ID]: adtCustomerCsNumberIdVal + ':' + adtCustomerCsSiteNoIdVal,
            [NoteAttribute.CLIENT_NAME]: ontech.state.get(State.CLIENT_NAME),
            [NoteAttribute.PARENT]: ontech.state.get(State.ParentOrder.NUMBER),
            [NoteAttribute.PARENT_WORK_ORDER]: ontech.state.get(State.ParentOrder.WORK_ORDER)
        }
    };
};

const hideShipmentBreadcrumb = () => {
    $(".breadcrumb__item").each(function(i, bi){
        let a,s;
        bi = $(bi);
        a = bi.find('a');
        s = bi.find('span');
        if(
            (!isEmpty(a) && a.html().equalsIgnoreCase(CONFIRM_SERVICE))
            || (!isEmpty(s) && s.html().equalsIgnoreCase(CONFIRM_SERVICE))
        ){
            hideElement(bi);
        }
    });
    $(".breadcrumb-item").each(function(i, bi){
        bi = $(bi);
        if(bi.html().equalsIgnoreCase(CONFIRM_SERVICE)){
            hideElement(bi);
        }
    });
};

const isJSMOrder = () => !isUndefinedOrNull(ontech.state.get(State.VENDOR_DEALS.REFERRER))
    && ontech.state.get(State.VENDOR_DEALS.REFERRER).includes("/pages/vendorDeals");